import { render, staticRenderFns } from "./CountdownComponent.vue?vue&type=template&id=09c5d1d2"
import script from "./CountdownComponent.vue?vue&type=script&lang=ts"
export * from "./CountdownComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports